import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHook() {
  return <section className="py-12 sm:py-16 lg:py-24 relative bg-dark-surface bg-noise border-b border-dark-border" data-id="element-135">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-136">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.8
      }} className="space-y-6 sm:space-y-8" data-id="element-137">
          <p className="text-lg sm:text-xl md:text-2xl text-gray-300 italic font-light leading-relaxed" data-id="element-138">
            "Son las{' '}
            <span className="text-gold font-semibold not-italic" data-id="element-139">11:30 PM</span>
            . Estás solo frente a una pantalla. La luz azul ilumina tu rostro
            mientras sientes ese vacío familiar en el pecho. Acabas de perder
            otra hora en scroll infinito o contenido del que te avergüenzas."
          </p>

          <div className="w-12 h-[1px] bg-gold/50 mx-auto" data-id="element-140" />

          <p className="text-base sm:text-lg md:text-xl text-gray-400 leading-relaxed" data-id="element-141">
            Prometiste que hoy sería diferente. Prometiste que irías al
            gimnasio, que trabajarías en tu proyecto, que tendrías energía. Pero
            la voluntad te falló. Otra vez. La{' '}
            <span className="text-red-400 font-medium" data-id="element-142">"resaca moral"</span> ha
            vuelto.
          </p>
        </motion.div>
      </div>
    </section>;
}